import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "message", "confirmButton", "cancelButton"]

  declare readonly modalTarget: HTMLElement
  declare readonly messageTarget: HTMLElement
  private resolve: (value: boolean) => void = () => {}

  connect() {
    // Override Turbo's confirm method
    // @ts-ignore
    window.Turbo.setConfirmMethod((message: string) => {
      return this.show(message)
    })
  }

  show(message: string): Promise<boolean> {
    this.messageTarget.textContent = message
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    
    // Lock scroll
    document.body.classList.add("overflow-hidden")

    return new Promise((resolve) => {
      this.resolve = resolve
    })
  }

  confirm() {
    this.hide()
    this.resolve(true)
  }

  cancel() {
    this.hide()
    this.resolve(false)
  }

  hide() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    document.body.classList.remove("overflow-hidden")
  }
}
